module.exports = __webpack_public_path__ + "static/img/menjinkaquanxian.112fd96f.png";